/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import UserEditForm from './UserEditForm'

export default function UserSelectedDetails({selected, setSelected}) {
  return (
    <div>
            {/* {selected?.name}
            {selected?.address}
            {selected?.email} */}
            {!selected ? 
                <div style={{width: '100%', height: '83vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <span className=''>Please select a user to view/edit.</span> 
                </div>
            :
                <div className='border p-2' style={{width: '100%', height: '83vh', display:'flex'}}>
                    <UserEditForm 
                        selected={selected}
                        setSelected={setSelected}
                    />
                </div>
            }
            
        </div>
  )
}
